
export const COLOCACION_DOCUMENTO_ENTITY_NAME = 'documento'

export interface ColocacionDocumento extends DenominableEntity {
  documento: string
  fechaAlta: string
}